<template>
  <v-container
    ref="market"
    v-if="!handleBlur"
    fluid
  >
    <the-markets-info />
  </v-container>
      <v-container v-else ref="market" fluid>
      <img src="../assets/blur_imgs/blur3.png"  :alt="$t('extras.blurredImageLockedMarketsAlt')">
  </v-container>
</template>

<script>
import ToolBar from "@/components/layout/ToolBar.vue";
import TheMarketsInfo from "@/components/QuartixMarkets/TheMarketsInfo.vue";
import { useCoreStore } from "@/store/coreStore";
import { mapStores } from "pinia";
export default {
  components: {
    ToolBar,
    TheMarketsInfo,
  },
  name: 'Market.Desk',
  data() {
    return {
      tab: null,
      defaultSelect: null,
    };
  },
  computed: {
    ...mapStores(useCoreStore),
    handleBlur() {
      return this.coreStore.evaluateBlur(this.$options.name, 'fixedincome')
    },
  },
};
</script>

<style scoped>
.market-container {
  display: grid;
  grid-template-rows: auto 1fr auto;
  gap: 0.2rem;
  height: 100% !important;
}
.difference-values {
  padding-top: 0.5rem;
  line-height: 0.15rem;
}
.view-more {
  display: flex;
}
.font-size-title {
  font-size: var(--news-font-size) !important;
}
/*
.news-chart, .cross-quotes{
  height:30%;
}
.p-chart, .economic-calendar{
  height:55%;
}

*/
.economic-calendar,
.p-chart,
.cross-quotes,
.news-chart {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: 100% !important;
}

.bottom-border {
  border-bottom: 1px solid #3d3d3d;
}

.border-calendar {
  position: fixed;
  right: 33%;
  top: 0%;
  height: 100%;
  border-right: 1px solid #3d3d3d;
}

.ui-row {
  min-height: 0;
  flex: 1 1 25vh;
  height: 27vh;
}
.ui-row:first-of-type {
  flex: 0.5 1 50%;
}

.ui-row:last-of-type {
  flex: 1.5 1 50%;
}
.ui-col {
  flex: 1 1 50% !important;
  display: flex;
  flex-direction: column;
}
.chart {
  max-width: 1940px;
  /* width: 1940px; */
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
}

.disable-focus:focus::before {
  opacity: 0 !important;
}
::v-deep .v-tabs-bar {
  width: 100% !important;
  padding: 0 !important;
  background: transparent !important;
}
::v-deep .v-slide-group__content {
  justify-content: center !important;
}
::v-deep .spotlight {
  background: rgba(255, 255, 255, 0.15) !important;
  backdrop-filter: blur(3.8px) !important;
  -webkit-backdrop-filter: blur(3.8px) !important;
  border: thin solid rgba(255, 255, 255, 0.4);
  border-radius: 16px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
}
</style>
